import { Card, Divider, Empty } from "antd";
import { useEffect, useCallback, useState } from "react";
import { BsTelephone } from "react-icons/bs";
import { CiMail } from "react-icons/ci";
import { RiWechatLine } from "react-icons/ri";
// import FreshchatWidget from "./fresh-chat";
import { useRef } from "react";
import Loader from "./loader";
import AuthService from "../services/auth.service";
import { useTranslation } from "react-i18next";
import FEATURE_CONFIG from "client/feature.config.json";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaTwitter } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";

export default function CallUsComponet() {
  const [dataSource, setDataSource] = useState([]);
  const unlistenRef = useRef(null);
  const { t } = useTranslation();
  useEffect(() => {
    getCallUsDetails();
  }, []);

  const getCallUsDetails = useCallback(async () => {
    try {
      const response = await AuthService.getCallUsDetails({});
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <div
        className="wrapper"
        style={{ borderRadius: "10px", padding: "10px" }}
      >
        {/* <Card
          // onClick={() => handleClick()}
          className="col-6 offset-3"
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex align-items-center justify-content-center ">
            <RiWechatLine
             className="primary-color"
              size={50}
              style={{ transform: "scalex(-1)" }}
            />

            <div>
              <h5 className="primary-color">Need Some Assistance ?</h5>
              <span className="call-us-font">Start a live chat</span>
            </div>
          </div>
        </Card> */}

        {dataSource.length === 0 && (
          <Empty
            description={t("pages.transfer_limit.no_record_found", {
              defaultValue: "No Record found",
            })}
          />
        )}

        {dataSource.length > 0 && (
          <>
            <div className="paragraph px-3">
              {/* <Divider type="horizontal">OR</Divider> */}
              {/* {dataSource.map((option, idx) => (
                <div key={idx}>
                  <h6 className="mb-4">
                    {option?.lable !== "IMPORTANT NOTICE"
                      ? option?.lable
                      : null}
                  </h6>
                  {option?.lable !== "IMPORTANT NOTICE" &&
                    option?.mobileNo?.map((data, indx) => (
                      <span
                        className="contact-tel-style"
                        style={{ marginRight: 20 }}
                        key={indx}
                      >
                        <BsTelephone className="primary-color" size={15} />
                        <span className="mx-2 text-bold">{FEATURE_CONFIG.TOLL_FREE_NO}</span>
                      </span>
                    ))}
                  {option?.lable !== "IMPORTANT NOTICE" && option?.email && (
                    <p className="mt-3">
                      <CiMail className="primary-color" size={15} />
                      <span
                        className="mx-3 text-bold primary-color"
                       
                        onClick={() =>
                          (window.location.href = `mailto:${FEATURE_CONFIG.MAIL_ID}`)
                        }
                      >
                        {FEATURE_CONFIG.MAIL_ID}
                      </span>
                    </p>
                  )}
                  {option?.lable !== "IMPORTANT NOTICE" && <Divider />}
                </div>
              ))} */}
              {dataSource.map((option, idx) => (
                <div key={idx}>
                  <h6 className="mb-4" style={{ fontWeight: 600 }}>
                    {option?.lable !== "IMPORTANT NOTICE"
                      ? option?.lable
                      : null}
                  </h6>
                  <div className="mb-2">
                    <span
                      className="contact-tel-style "
                      style={{ marginRight: 20 }}
                    >
                      <h6 className="text-bold" style={{ fontWeight: 600 }}>Head Office</h6>
                      <span className="text-bold">
                      4th floor, Rwenzori Courts, Nakasero Rd, Kampala, Uganda.
                      </span>
                    </span>
                  </div>

                  {option?.lable !== "IMPORTANT NOTICE" && option?.email && (
                    <p className="mt-3">
                      <h6 className="text-bold" style={{ fontWeight: 600 }}>Email</h6>
                      <span
                        className="text-bold primary-color"
                        onClick={() =>
                          (window.location.href = `mailto:${FEATURE_CONFIG.MAIL_ID}`)
                        }
                      >
                        {FEATURE_CONFIG.MAIL_ID}
                      </span>
                    </p>
                  )}

                 
                  {option?.lable !== "IMPORTANT NOTICE" &&
                    option?.mobileNo?.map((data, indx) => (
                      <p className="mt-3">
                      <h6 className="text-bold" style={{ fontWeight: 600 }}>Phone</h6>
                      <span
                        className="contact-tel-style"
                        style={{ marginRight: 20 }}
                        key={indx}
                      >
                        <span className=" text-bold">{FEATURE_CONFIG.TOLL_FREE_NO}</span>
                      </span>
                      </p>
                    ))}
                
                  <div>
                    <span
                      className="contact-tel-style"
                      style={{ marginRight: 20 }}
                    >
                      <h6 className="text-bold" style={{ fontWeight: 600 }}>Website</h6>
                      <span className="d-flex">
                        {/* <MdOutlineComputer className="primary-color mt-1" size={15} /> */}
                        <span className="text-bold">
                          <a
                            href={FEATURE_CONFIG.TOP_BANNER_LINK}
                            target="_blank"
                            style={{
                              color: "var(--primary_color)",
                              textDecoration: "none",
                            }}
                          >
                           {FEATURE_CONFIG.TOP_BANNER_LINK}
                          </a>
                        </span>
                      </span>
                    </span>
                  </div>
                  

                  <div>
                    <span
                      className="contact-tel-style"
                      style={{ marginRight: 20 }}
                    >
                      <h6 className="text-bold" style={{ fontWeight: 600 }}>Working hours</h6>
                      <span className="text-bold">Monday to Friday 8:30 am–5:00 pm, Closed on Saturday and Sunday.</span>
                    </span>
                  </div>
                  {option?.lable !== "IMPORTANT NOTICE" && <Divider />}
                </div>
              ))}
              <div>
                <h6 align="center" className="mb-4"> Follow Us On</h6>
              <div align="center">
               <a href={FEATURE_CONFIG.FACEBOOK_APP_LINK} target="_blank" rel="noopener noreferrer">
              <FaFacebook style={{ marginRight: "10px" }} />
            </a>
            <Divider type="vertical" className="custom-divider" />
            <a href={FEATURE_CONFIG.TWITTER_APP_LINK} target="_blank" rel="noopener noreferrer">
              <FaTwitter style={{ marginRight: "10px" }} />
            </a>
            <Divider type="vertical" className="custom-divider" />
            <a href={FEATURE_CONFIG.LINKEDIN_APP_LINK} target="_blank" rel="noopener noreferrer">
              <FaLinkedin style={{ marginRight: "10px" }} />
            </a>
            {FEATURE_CONFIG.TIKTOK_APP_LINK && (
              <>
            <Divider type="vertical" className="custom-divider" />
            <a href={FEATURE_CONFIG.TIKTOK_APP_LINK} target="_blank" rel="noopener noreferrer">
              <FaTiktok style={{ marginRight: "10px" }} />
            </a>
            </>
            )}
             {FEATURE_CONFIG.YOUTUBE_LINK && (
              <>
            <Divider type="vertical" className="custom-divider" />
            <a href={FEATURE_CONFIG.YOUTUBE_LINK} target="_blank" rel="noopener noreferrer">
              <FaYoutube style={{ marginRight: "10px" }} />
            </a>
            </>
              )}
            {/* <a href={FEATURE_CONFIG.INSTAGRAM_LINK} target="_blank" rel="noopener noreferrer">
              <AiFillInstagram style={{ marginRight: "10px" }} />
            </a> */}
            <Divider type="vertical" className="custom-divider" />
            </div>
            </div>
            </div>
          </>
        )}
        {/* <FreshchatWidget /> */}
      </div>
    </>
  );
}
